import * as React from 'react';
import { useSelector } from 'react-redux';
import { Layout } from '../../components/Layout';
import { VideoCarousel } from '../../components/VideoCarousel';
import { VideoPlayer } from '../../components/VideoPlayer';
import { VideoPreview } from '../../components/VideoPreview';
import { getVideos } from '../../selectors/newbuilding';

export const Video = () => {
  const video = useSelector(getVideos);
  const [currentSlide, setCurrentSlide] = React.useState(1);

  const onSlideChange = React.useCallback((currentSlide: number) => setCurrentSlide(currentSlide), []);

  if (!video.length) {
    return null;
  }

  if (video.length > 1) {
    return (
      <Layout>
        <VideoCarousel
          onSlideChange={onSlideChange}
          slides={video.map((item, index) => (
            <VideoPlayer
              key={item.videoId}
              preview={<VideoPreview fallback={item.thumbnailUrl} url={item.fullUrl} />}
              videoId={item.videoId}
              type={item.type}
              src={item.url}
              isCurrent={currentSlide === index + 1}
            />
          ))}
        />
      </Layout>
    );
  }

  return (
    <Layout>
      <VideoPlayer
        preview={<VideoPreview fallback={video[0].thumbnailUrl} url={video[0].fullUrl} />}
        videoId={video[0].videoId}
        type={video[0].type}
        src={video[0].url}
      />
    </Layout>
  );
};
